import React, { useEffect, useState, useCallback } from 'react';
import api from '../api';
import { CLIENT_URL } from '../config';
import { useAdminLanguage } from '../AdminLanguageContext';
import useAdminDialog from '../components/AdminDialog';

const statusBadge = { open: 'badge-green', in_progress: 'badge-orange', completed: 'badge-blue', closed: 'badge-gray' };

export default function Tasks() {
  const { copy } = useAdminLanguage();
  const tasksCopy = copy.tasks;
  const [data, setData] = useState({ tasks: [], total: 0 });
  const [keyword, setKeyword] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const { confirmAction, dialog } = useAdminDialog();

  const fetch = useCallback(() => {
    setLoading(true);
    api.get('/admin/tasks', { params: { keyword, status: statusFilter, page, limit: 20 } })
      .then(res => setData(res.data))
      .finally(() => setLoading(false));
  }, [keyword, statusFilter, page]);

  useEffect(() => { fetch(); }, [fetch]);

  const handleStatus = async (id, status) => {
    await api.put(`/admin/tasks/${id}/status`, { status });
    fetch();
  };

  const handleDelete = async (id) => {
    if (!await confirmAction({
      title: tasksCopy.deleteConfirm.title,
      message: tasksCopy.deleteConfirm.message,
      variant: 'danger',
    })) return;
    await api.delete(`/admin/tasks/${id}`);
    fetch();
  };

  return (
    <div>
      {dialog}
      <div className="page-title">{tasksCopy.title}</div>
      <div className="card">
        <div style={{ display: 'flex', gap: 12, marginBottom: 16, alignItems: 'center', flexWrap: 'wrap' }}>
          <div className="search-input" style={{ margin: 0 }}>
            <input placeholder={tasksCopy.searchPlaceholder} value={keyword}
              onChange={e => { setKeyword(e.target.value); setPage(1); }} />
          </div>
          <select style={{ padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 13 }}
            value={statusFilter} onChange={e => { setStatusFilter(e.target.value); setPage(1); }}>
            <option value="">{tasksCopy.allStatus}</option>
            <option value="open">{tasksCopy.status.open}</option>
            <option value="in_progress">{tasksCopy.status.in_progress}</option>
            <option value="completed">{tasksCopy.status.completed}</option>
            <option value="closed">{tasksCopy.status.closed}</option>
          </select>
          <span style={{ fontSize: 13, color: '#6b7280', marginLeft: 'auto' }}>{tasksCopy.total(data.total)}</span>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>{tasksCopy.columns.id}</th><th>{tasksCopy.columns.title}</th><th>{tasksCopy.columns.category}</th><th>{tasksCopy.columns.owner}</th>
                <th>{tasksCopy.columns.budget}</th><th>{tasksCopy.columns.bids}</th><th>{tasksCopy.columns.status}</th><th>{tasksCopy.columns.createdAt}</th><th>{tasksCopy.columns.actions}</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={9} style={{ textAlign: 'center', color: '#9ca3af', padding: 32 }}>{tasksCopy.loading}</td></tr>
              ) : data.tasks.map(t => (
                <tr key={t.id}>
                  <td>{t.id}</td>
                  <td style={{ maxWidth: 200, fontWeight: 500 }}>
                    <a href={`${CLIENT_URL}/tasks/${t.id}`} target="_blank" rel="noreferrer"
                      style={{ color: '#4154f1' }}>{t.title}</a>
                  </td>
                  <td><span className="badge badge-blue">{t.category}</span></td>
                  <td style={{ color: '#6b7280' }}>{t.owner_name}</td>
                  <td style={{ fontWeight: 600 }}>¥{t.budget_min}-{t.budget_max}</td>
                  <td>{t.bid_count}</td>
                  <td><span className={`badge ${statusBadge[t.status] || 'badge-gray'}`}>{tasksCopy.status[t.status] || t.status}</span></td>
                  <td style={{ color: '#6b7280' }}>{new Date(t.created_at).toLocaleDateString()}</td>
                  <td>
                    <div style={{ display: 'flex', gap: 6 }}>
                      {t.status !== 'closed' ? (
                        <button className="btn btn-sm btn-warning" onClick={() => handleStatus(t.id, 'closed')}>{tasksCopy.actions.close}</button>
                      ) : (
                        <button className="btn btn-sm btn-outline" onClick={() => handleStatus(t.id, 'open')}>{tasksCopy.actions.restore}</button>
                      )}
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(t.id)}>{tasksCopy.actions.delete}</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="pagination">
          <button className="btn btn-sm btn-outline" disabled={page === 1} onClick={() => setPage(p => p - 1)}>{tasksCopy.previous}</button>
          <span>{tasksCopy.page(page)}</span>
          <button className="btn btn-sm btn-outline" disabled={page * 20 >= data.total} onClick={() => setPage(p => p + 1)}>{tasksCopy.next}</button>
        </div>
      </div>
    </div>
  );
}
